import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { ISites } from '../Interfaces/ISites';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { GeneralServices } from '../services/general-services';
import { IBenefit } from '../Interfaces/IBenefit';
import { IEmployeesInActiveDirectory } from '../Interfaces/IEmployeesInActiveDirectory';
import { ActiveDirectoryService } from './activedirectory-service';

@Injectable({
	providedIn: 'root',
})
export class SitesService extends RestCallService {
	public dataToSend: ISites = {
		pk_site: 0,
		site: '',
		creation_date: new Date(),
		str_creation_date: '',
		fk_employee_creator: 1,
		last_updated: new Date(),
		str_last_updated: '',
		fk_employee_updater: 1,
		employee_creator_name: '',
		employee_updater_name: '',
		username: '',
		record_status_name: '',
		fk_employee: 0,
		available: false,
		building: '',
		fk_building: 0,
		level: 0,
		fk_site: 0,
		pk_building: 0,
		active: false,
		fk_site_logged_user: 0,
		timezone: '',
		fk_language: 0,
		language: '',
	};

	public benefitsDataToSend: IBenefit = {
		pk_benefit: 0,
		benefit: '',
		elegibility: '',
		restriction: '',
		contact: '',
		coverture_details: '',
		benefit_process: '',
		politics: '',
		fk_site: 0,
		site: '',
		fk_pay_grade: 0,
		pay_grade: '',
		fk_pay_rate_type: 0,
		pay_rate_type: '',
		fk_job_category: 0,
		job_Category: '',
		fk_employee_type: 0,
		employee_type: '',
		creation_date: new Date(),
		last_update: new Date(),
		fk_record_status: 0,
		file_benefits_process: '',
		file_coverture_details: '',
		file_politicts: '',
		fk_external_links: '',
		img_Icon: '',
		img_Icon_temp: '',
		img_banner: '',
		type: '',
		external_link_description: '',
		external_link_image_url: '',
		external_link_link: '',
		external_link_name: '',
		username: '',
		external_links: '',
		fk_site_logged_user: 0,
		type_of_file: '',
		fk_user_creator: 0,
		fk_user_updater: 0,
	};

	constructor(
		public httpClient: HttpClient,
		private generalServices: GeneralServices,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
		private activeDirectoryService: ActiveDirectoryService,
	) {
		super(
			httpClient,
			'API_Benefits',
			toastr,
			notificationService,
			translate,
		);
	}

	public GetAll() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site = parseInt(
			localStorage.getItem('fksite'),
		);

		return this.post<ISites[]>('/api/Sites/GetAll', this.dataToSend);
	}

	public GetAvailable() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<ISites[]>('/api/Sites/GetAvailable', this.dataToSend);
	}

	public ChangeStatus(data: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.pk_site = data.pk_site;
		this.dataToSend.fk_site = parseInt(
			localStorage.getItem('fksite'),
		);

		return this.put('/api/Sites/ChangeStatus', this.dataToSend);
	}

	public BenefitSiteChangeStatus(data: any, pk_benefit: any) {
		this.generalServices.ValidateCognito();
		this.benefitsDataToSend.fk_site = data.pk_site;
		this.benefitsDataToSend.pk_benefit = pk_benefit;
		this.benefitsDataToSend.fk_record_status = data.fkrecordstatus;
		this.benefitsDataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.put('/api/Sites/BenefitSiteChangeStatus', this.benefitsDataToSend);
	}

	public GetSitesByUsername() {
		this.generalServices.ValidateCognito();
		this.dataToSend.username = this.activeDirectoryService.employee.workdayId;
		return this.post<ISites[]>(
			'/api/Sites/GetSitesByUsername',
			this.dataToSend,
		);
	}

	public GetSitesByUsernameAndBenefit(data: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		this.dataToSend.pk_site = data;
		return this.post<ISites[]>(
			'/api/Sites/GetSitesByUsernameAndBenefit',
			this.dataToSend,
		);
	}

	public GetSitesByBenefit(data: any) {
		this.generalServices.ValidateCognito();
		this.benefitsDataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		this.benefitsDataToSend.pk_benefit = data;
		return this.post<ISites[]>(
			'/api/Sites/GetSitesByBenefit',
			this.benefitsDataToSend,
		);
	}

	public IsActiveSite() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<ISites>('/api/Sites/isActive', this.dataToSend);
	}

	public GetTimeZones() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<any[]>('/api/Sites/GetTimeZones', this.dataToSend);
	}

	public GetLanguages() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site_logged_user = parseInt(
			localStorage.getItem('fksite'),
		);
		return this.post<any[]>('/api/Sites/GetLanguages', this.dataToSend);
	}

	public GetCurrentSite() {
		this.generalServices.ValidateCognito();
		this.dataToSend.fk_site = parseInt(localStorage.getItem('fksite'));

		return this.post<ISites[]>(
			'/api/Sites/GetCurrentSite',
			this.dataToSend,
		);
	}

	public Create(data: any, employee: IEmployeesInActiveDirectory){
		this.generalServices.ValidateCognito();

		this.dataToSend.site = data.txtSite;
		this.dataToSend.timezone = data.cbTimeZone;
		this.dataToSend.fk_language = data.cbLanguages;
		this.dataToSend.administrator = {
			username: employee.userName,
			workday_id: employee.workdayId,
			employee_name: employee.name,
			email: employee.email
		};

		return this.post<ISites[]>('/api/Sites/Create', this.dataToSend);
	}

	public Update(data: any) {
		this.generalServices.ValidateCognito();
		this.dataToSend.pk_site = data.pk_site;
		this.dataToSend.site = data.txtSite;
		this.dataToSend.timezone = data.cbTimeZone;
		this.dataToSend.fk_language = data.cbLanguages;

		return this.put<any[]>(
			'/api/Sites/Update',
			this.dataToSend,
		);
	}

	public GetSitesByRole(){
		this.generalServices.ValidateCognito();

		return this.post<ISites[]>('/api/Sites/GetSitesByRole', this.dataToSend);
	}
}
